import React from 'react';
import { ArrowRight, Star, ExternalLink } from 'lucide-react';

const Hero = () => {
  const scrollToMenu = () => {
    document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleOrderNow = () => {
    window.open('https://order.toasttab.com/online/hot-slice-pizza-41-dravus-street', '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="/hero-background.jpg"
          alt="Hot Slice Pizza - Pizzas, Calzones, Pasta and Salads"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/85 via-gray-900/60 to-gray-900/85"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 max-w-4xl mx-auto">
        <div className="flex items-center justify-center space-x-1 mb-4">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="h-4 w-4 sm:h-5 sm:w-5 text-yellow-400 fill-current" />
          ))}
          <span className="text-cream-100 ml-2 font-medium text-sm sm:text-base">Authentic NY Style Pizza</span>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight font-pizza">
          <span className="font-extrabold">Hot Slice</span>
          <span className="text-red-600 block font-extrabold">Pizza</span>
        </h1>

        <p className="text-lg sm:text-xl md:text-2xl text-cream-100 mb-6 sm:mb-8 max-w-2xl mx-auto leading-relaxed px-4">
          Authentic NY style pizza by the slice, fresh pasta, and delicious appetizers crafted with expertise in the heart of Seattle.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 px-4">
          <button
            onClick={handleOrderNow}
            className="group bg-red-600 hover:bg-red-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg transition-all duration-300 transform hover:scale-105 flex items-center space-x-2 w-full sm:w-auto justify-center"
          >
            <span>Order Now</span>
            <ExternalLink className="h-4 w-4 sm:h-5 sm:w-5 group-hover:translate-x-1 transition-transform duration-200" />
          </button>

          <button
            onClick={scrollToMenu}
            className="border-2 border-green-600 text-green-400 hover:bg-green-600 hover:text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-base sm:text-lg transition-all duration-300 w-full sm:w-auto flex items-center justify-center space-x-2"
          >
            <span>View Menu</span>
            <ArrowRight className="h-4 w-4 sm:h-5 sm:w-5" />
          </button>
        </div>

        <div className="mt-8 sm:mt-12 grid grid-cols-3 gap-4 sm:gap-8 max-w-3xl mx-auto px-4">
          <div className="text-center">
            <div className="text-2xl sm:text-3xl font-bold text-red-600 mb-1 sm:mb-2">40+</div>
            <div className="text-cream-100 font-medium text-sm sm:text-base">Menu Items</div>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl font-bold text-green-600 mb-1 sm:mb-2">9</div>
            <div className="text-cream-100 font-medium text-sm sm:text-base">Gelato Flavors</div>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl font-bold text-yellow-600 mb-1 sm:mb-2">New</div>
            <div className="text-cream-100 font-medium text-sm sm:text-base">Family Owned</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;